import EditIcon from "../../../assets/images/Edit.svg";
import { Card, Status, Edit, Icon, IconImage, Description } from "./styles";

interface cardProps {
  status: string;
  icon: string;
  descrip: string;
  toggle?: () => void;
}
export function CardComponent({ status, icon, descrip, toggle }: cardProps) {
  return (
    <Card>
      {status ? (
        <Status
          // @ts-ignore
          status={status}
        >
          {status}
        </Status>
      ) : null}
      <Edit>
        <img src={EditIcon} alt="" onClick={toggle} />
      </Edit>
      <div className="my-[1.5em]">
        <Icon>
          <IconImage src={icon} />{" "}
        </Icon>
        <Description>{descrip}</Description>
      </div>
    </Card>
  );
}
